import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../lib/api';

export default function Resources() {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchResources = async () => {
    try {
      const res = await api.get('/admin/resources');
      setResources(res.data?.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResources();
  }, []);

  const deleteResource = async (id) => {
    if (!window.confirm('Delete this resource?')) return;

    try {
      await api.delete(`/admin/resources/${id}`);
      setResources((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      alert(err.response?.data?.message || 'Unable to delete resource');
    }
  };

  if (loading) {
    return <div className="p-6">Loading resources...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-3xl font-black text-text">Resource Management</h1>
          <p className="mt-2 text-muted">
            Upload, publish, and manage books, videos, downloads, and protected links.
          </p>
        </div>

        <Link
          to="/dashboard/admin/resources/create"
          className="inline-flex items-center justify-center rounded-2xl bg-primary px-5 py-3 text-sm font-bold text-white"
        >
          Create resource
        </Link>
      </div>

      <div className="grid gap-6 lg:grid-cols-2 xl:grid-cols-3">
        {resources.map((resource) => (
          <div key={resource.id} className="rounded-3xl border border-black/5 bg-white p-5 shadow-sm">
            {resource.cover_image_url && (
              <img
                src={process.env.REACT_APP_IMAGE_URL_NO_TRAIL + resource.cover_image_url}
                alt={resource.title}
                className="mb-4 h-44 w-full rounded-2xl object-cover"
              />
            )}

            <div className="flex items-center justify-between gap-3">
              <h2 className="text-xl font-bold text-text">{resource.title}</h2>
              <span className={`rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide ${
                resource.is_published
                  ? 'bg-green-100 text-green-700'
                  : 'bg-gray-100 text-gray-600'
              }`}>
                {resource.is_published ? 'Published' : 'Draft'}
              </span>
            </div>

            <p className="mt-3 text-sm leading-6 text-muted">{resource.summary}</p>

            <div className="mt-4 flex flex-wrap gap-2">
              <span className="rounded-full bg-primary/10 px-3 py-1 text-[11px] font-bold uppercase text-primary">
                {resource.audience}
              </span>
              {resource.has_download && (
                <span className="rounded-full bg-secondary/10 px-3 py-1 text-[11px] font-bold uppercase text-secondary">
                  Download
                </span>
              )}
              {resource.has_video_file && (
                <span className="rounded-full bg-secondary/10 px-3 py-1 text-[11px] font-bold uppercase text-secondary">
                  Video File
                </span>
              )}
              {resource.has_video_url && (
                <span className="rounded-full bg-secondary/10 px-3 py-1 text-[11px] font-bold uppercase text-secondary">
                  Video Link
                </span>
              )}
            </div>

            <div className="mt-6 flex items-center justify-between">
              <span className="text-lg font-black text-primary">
                ₦{Number(resource.price).toLocaleString()}
              </span>

              <div className="flex items-center gap-2">
                <Link
                  to={`/dashboard/admin/resources/${resource.id}/edit`}
                  className="rounded-xl border border-primary/15 bg-white px-4 py-2 text-sm font-bold text-primary"
                >
                  Edit
                </Link>
                <button
                  onClick={() => deleteResource(resource.id)}
                  className="rounded-xl border border-red-200 bg-red-50 px-4 py-2 text-sm font-bold text-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}